import React, { useState, useEffect, useRef } from 'react';
import { Users, Home, Star, MapPin } from 'lucide-react';

const stats = [
  {
    icon: Users,
    value: 500,
    suffix: '+',
    label: 'Trusted Agents',
    description: 'In our network'
  },
  {
    icon: Home,
    value: 2500,
    suffix: '+',
    label: 'Properties Matched',
    description: 'Successfully connected'
  },
  {
    icon: Star,
    value: 4.9,
    suffix: '',
    label: 'Average Rating',
    description: 'From happy clients'
  },
  {
    icon: MapPin,
    value: 200,
    suffix: '+',
    label: 'Suburbs Covered',
    description: 'Across Australia'
  }
];

const AnimatedCounter = ({ value, suffix, isVisible }) => {
  const [count, setCount] = useState(0);
  
  useEffect(() => {
    if (!isVisible) return;
    
    const duration = 2000;
    const steps = 50;
    const stepValue = value / steps;
    const stepDuration = duration / steps;
    
    let current = 0;
    const timer = setInterval(() => {
      current += stepValue;
      if (current >= value) {
        setCount(value);
        clearInterval(timer);
      } else {
        setCount(Math.floor(current * 10) / 10);
      }
    }, stepDuration);
    
    return () => clearInterval(timer);
  }, [value, isVisible]);
  
  return (
    <span>
      {Number.isInteger(value) ? Math.floor(count).toLocaleString() : count.toFixed(1)}
      {suffix}
    </span>
  );
};

const Stats = () => {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);
  
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.3 }
    );
    
    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }
    
    return () => observer.disconnect();
  }, []);

  return (
    <section className="stats-section" ref={sectionRef}>
      <div className="stats-container">
        <div className="stats-header">
          <h2 className="stats-title">Trusted by Australians</h2>
          <p className="stats-subtitle">Join thousands who found their perfect agent through FindMeAgent</p>
        </div>
        <div className="trust-stats-grid">
          {stats.map((stat, index) => (
            <div key={index} className="trust-stat-card">
              <div className="trust-stat-icon-wrapper">
                <stat.icon className="trust-stat-icon" size={32} />
              </div>
              <div className="trust-stat-value">
                <AnimatedCounter value={stat.value} suffix={stat.suffix} isVisible={isVisible} />
              </div>
              <div className="trust-stat-label">{stat.label}</div>
              <div className="trust-stat-description">{stat.description}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Stats;
